import http from './httpClient';

const MinimalStockService = {
  async getCriticalItems(businessId, language = 'en') {
    return await http.get(`/minimal-stock/critical-items/${businessId}?language=${language}`);
  },
  async getDashboardAlerts(businessId, language = 'en') {
    return await http.get(`/minimal-stock/dashboard-alerts/${businessId}?language=${language}`);
  },
  async getTrackingStatus(businessId) {
    return await http.get(`/minimal-stock/tracking-status/${businessId}`);
  },
  async calculateReorderPoints(businessId) {
    return await http.post('/minimal-stock/calculate-reorder-points', { businessId });
  },
  async transitionPhases(businessId) {
    return await http.post('/minimal-stock/transition-phases', { businessId });
  },
  async bulkUpdateReorderPoints(businessId, updates) {
    return await http.put('/minimal-stock/bulk-update-reorder-points', { updates });
  }
};

export default MinimalStockService;
